import { fetch } from "./API";

export const FetchProviders = async (query: {} | undefined) => {
  try {
    return await fetch(
      `${process.env.REACT_APP_API_URL}/providers`,
      { ...query }
    );
  } catch (err: any) {
    if (err.request) return err.request;
    if (err.response) return err.response;
    return err.message;
  }
};
